import { all, takeLatest, call, put } from 'redux-saga/effects';
import { ActionType } from 'deox';
import { RegionsInstance } from '@/services/country-information';
import {
  fetchRegionsActions,
  fetchCountriesByRegionActions,
  fetchCurrenciesActions
} from '@/redux/actions/country-information';

export function* fetchRegionsSaga() {
  try {
    const { data, paging } = yield call(RegionsInstance.fetchRegions);
    yield put(fetchRegionsActions.success(data, paging));
  } catch (err) {
    yield put(fetchRegionsActions.failure(err));
  }
}

export function* fetchCurrenciesSaga() {
  try {
    const { data, paging } = yield call(RegionsInstance.fetchCurrencies);
    yield put(fetchCurrenciesActions.success(data, paging));
  } catch (err) {
    yield put(fetchCurrenciesActions.failure(err));
  }
}

export function* fetchCountriesByRegionSaga(
  action: ActionType<typeof fetchCountriesByRegionActions.request>,
) {
  const { regionName } = action.payload;
  try {
    const { data, paging, meta } = yield call(RegionsInstance.fetchCountriesByRegion, regionName);
    yield put(fetchCountriesByRegionActions.success(data, paging, meta));
  } catch (err) {
    yield put(fetchCountriesByRegionActions.failure(err));
  }
}

export default function* root() {
  yield all([
    takeLatest(fetchRegionsActions.request.type, fetchRegionsSaga),
    takeLatest(fetchCurrenciesActions.request.type, fetchCurrenciesSaga),
    takeLatest(fetchCountriesByRegionActions.request.type, fetchCountriesByRegionSaga),
  ]);
}
